import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Avatar } from 'components/common';

/**
 * One renderer for every company party column (customer, enduser, contractor,
 * consultant) instead of four near-identical Link renderers.
 *
 * The company's uploaded logo leads the cell; a company without one gets an
 * initials avatar from its name, so every row carries the same visual anchor
 * and the eye can scan the column by mark rather than by reading each name.
 */
const CompanyCellRenderer = ({ value, party }) => {
  if (!party?.id || !value) return <span className="tw-text-slate-300">—</span>;

  return (
    <span className="tw-inline-flex tw-items-center tw-gap-2 tw-max-w-full">
      <Avatar src={party.logo_url || undefined} name={value} alt={value} size="xs" className="tw-shrink-0" />
      <Link to={`/crm/customers/${party.id}`} target="_blank" className="tw-truncate">{value}</Link>
    </span>
  );
};

CompanyCellRenderer.propTypes = {
  value: PropTypes.string,
  party: PropTypes.shape({ id: PropTypes.number, logo_url: PropTypes.string }),
};

// AG Grid instantiates cell renderers itself, so the party key is bound via
// cellRendererParams-free wrappers — one per column, matching the data field.
export const CustomerCell = (props) => <CompanyCellRenderer value={props.value} party={props.data?.customer} />;
export const EndUserCell = (props) => <CompanyCellRenderer value={props.value} party={props.data?.enduser} />;
export const ContractorCell = (props) => <CompanyCellRenderer value={props.value} party={props.data?.contractor} />;
export const ConsultantCell = (props) => <CompanyCellRenderer value={props.value} party={props.data?.consultant} />;

const gridProps = { value: PropTypes.string, data: PropTypes.object };
CustomerCell.propTypes = gridProps;
EndUserCell.propTypes = gridProps;
ContractorCell.propTypes = gridProps;
ConsultantCell.propTypes = gridProps;

export default CompanyCellRenderer;
